import { render } from "./ThankYouPageBLG.vue?vue&type=template&id=8cc2990e&scoped=true"
import script from "./ThankYouPageBLG.vue?vue&type=script&lang=js"
export * from "./ThankYouPageBLG.vue?vue&type=script&lang=js"

import "./ThankYouPageBLG.vue?vue&type=style&index=0&id=8cc2990e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cc2990e"]])

export default __exports__